var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row",attrs:{"id":_vm.componentId+'-plot_area'}})
}
var staticRenderFns = []

export { render, staticRenderFns }